import { matchCriteriaOptions, type MatchOptions } from 'components/Dialogs/ScheduledTransactionEditDialog/types';

export type MatchCriteriaSetters = {
  setMatchCriteria: (value: MatchOptions) => unknown;
  setMatchAnyAmount: (value: boolean) => unknown;
  setMatchAmountVariance: (value: number) => unknown;
  setResetMatchAmountVariance: (value: boolean) => unknown;
};

const MATCH_CRITERIA_VALUES: string[] = Object.values(matchCriteriaOptions);

/**
 * Applies a Match Criteria select change to the shared series form. Shared
 * between the Bill Setup Amount card and the Create/Edit Series Amount card,
 * which both offer the same four options with the same side effects.
 *
 * `nextValue` is typed as `string` (rather than `MatchOptions`) because the
 * Create/Edit Series select also has a non-selectable "Learn More" info menu
 * item sharing the same `onChange` — passing its value through here is a
 * no-op rather than corrupting `matchCriteria`.
 */
export function applyMatchCriteriaChange(
  nextValue: string,
  setters: MatchCriteriaSetters,
  limitedRangeVariance = 15,
): void {
  if (MATCH_CRITERIA_VALUES.includes(nextValue)) {
    setters.setMatchCriteria(nextValue as MatchOptions);
  }
  if (nextValue === matchCriteriaOptions.AUTO_MATCH) {
    setters.setResetMatchAmountVariance(true);
    setters.setMatchAnyAmount(false);
  } else if (nextValue === matchCriteriaOptions.ANY_AMOUNT) {
    setters.setMatchAnyAmount(true);
    setters.setResetMatchAmountVariance(true);
  } else if (nextValue === matchCriteriaOptions.EXACT_AMOUNT) {
    setters.setMatchAmountVariance(0);
    setters.setResetMatchAmountVariance(false);
    setters.setMatchAnyAmount(false);
  } else if (nextValue === matchCriteriaOptions.LIMITED_RANGE) {
    setters.setMatchAmountVariance(limitedRangeVariance);
    setters.setResetMatchAmountVariance(false);
    setters.setMatchAnyAmount(false);
  }
}
